module.exports = __webpack_public_path__ + "img/logo_id.fb5b0f85.svg";